import {z} from 'zod';

export const webhookIntegrationItemSchema = z.object({
    id: z.number(),
    name: z.string(),
    webhookId: z.string(),
    canBeDeleted: z.boolean(),
});

export type WebhookIntegrationItemType = z.infer<typeof webhookIntegrationItemSchema>;

export type CreateWebhookIntegrationType = Pick<WebhookIntegrationItemType, 'name' | 'webhookId'>;
export type UpdateWebhookIntegrationType = Pick<WebhookIntegrationItemType, 'id' | 'name'>;
